const MAX_DEFAULT_PITCH = 60
const MAX_3D_TERRAIN_PITCH = 70

/**
 * Tries to find terrain exaggeration for 3D map styles.
 * @param {import("maplibre-gl").Map} map
 * @returns {number} If not found, it returns default value
 */
function getExaggeration(map) {
    const defaultValue = 2
    try {
        return map.style.stylesheet.sources.terrain.exaggeration || defaultValue
    } catch (e) {
        return defaultValue
    }
}

/**
 * Add terrain if 3D map style is selected or remove it for other map styles.
 * @param {import("maplibre-gl").Map} map
 * @returns {void}
 */
export function handle3DTerrainChange(map) {
    if (map.style.stylesheet.sources.terrain) {
        if (!map.getTerrain()) {
            map.setTerrain({
                source: 'terrain',
                exaggeration: getExaggeration(map),
            })
            map.setMaxPitch(MAX_3D_TERRAIN_PITCH)
        }
    } else {
        if (map.getTerrain()) {
            map.setTerrain(null)
            map.setMaxPitch(MAX_DEFAULT_PITCH)
        }
    }
}
